// extracted by mini-css-extract-plugin
export var column = "_ti-0";
export var divider = "_ti-2";
export var timePicker = "_ti-1";